'use client'

import React, { useLayoutEffect, Suspense } from 'react'
import { useSearchParams } from 'next/navigation'
import SymbolPage from '../page'
import Presence from '../../components/Presence/Presence'

// baby: Inner content that uses useSearchParams (must be under Suspense for prerender)
function InstancePageContent() {
  const searchParams = useSearchParams()
  const params = searchParams ?? new URLSearchParams()
  const layout = params.get('layout')
  const widgetMap = params.get('widgetMap')

  useLayoutEffect(() => {
    if (layout && typeof window !== 'undefined') {
      try {
        localStorage.removeItem('myLayout')
        const decodedLayout = decodeURIComponent(layout)
        localStorage.setItem('myLayout', decodedLayout)
      } catch (error) {
        console.error('Error updating myLayout from URL:', error)
      }
    }
    if (widgetMap && typeof window !== 'undefined') {
      try {
        localStorage.removeItem('myWidgetMap')
        const decodedWidgetMap = decodeURIComponent(widgetMap)
        localStorage.setItem('myWidgetMap', decodedWidgetMap)
      } catch (error) {
        console.error('Error updating myWidgetMap from URL:', error)
      }
    }
  }, [layout, widgetMap])

  const userId = `user-${Math.floor(Math.random() * 10000)}`
  const userName = 'User'
  const symbol = params.get('symbol') || 'BTCUSDT'

  return (
    <Presence roomId={symbol} userId={userId} userName={userName}>
      <SymbolPage />
    </Presence>
  )
}

export default function InstancePage() {
  return (
    <Suspense fallback={
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>Loading...</div>
    }>
      <InstancePageContent />
    </Suspense>
  )
}
